import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseShape } from '../base-shape/component.js';
import { pathsMap } from './paths.js';
import 'classnames';
import '@alfalab/hooks';
import '../base-shape/utils.js';

var Circle = forwardRef(function (props, ref) { return (React.createElement(BaseShape, __assign({}, props, { pathsMap: pathsMap, ref: ref }))); });

export { Circle };
